export default "__VITE_ASSET__BdPyrn_T__"